import { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { useWorkspaceCalendarChannel } from './useWorkspaceCalendarChannel'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const WorkspaceCalendarChannelProvider = observer(({ children }: { children: ReactNode }) => {
  const calendarV2 = useFlipperFlag('calendar_v2')
  useWorkspaceCalendarChannel(calendarV2)
  return <>{children}</>
})
